import React, { Fragment } from 'react';
import cl from 'classnames';
import { BreadCrumb } from 'src/interface';
import { useContextData } from 'src/hooks';
import { useAppDispatch } from 'src/store';
import { clearReportsHeadsetsState } from 'src/store/reducers/reportHeadsets';
import { Link } from 'src/components/general';
import styles from './breadCrumbsStyle.module.scss';

const slashSVG = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.26419 4.18663C9.3114 4.0736 9.42191 4 9.54441 4C9.76122 4 9.9082 4.22067 9.82462 4.42074L6.73656 11.8134C6.68935 11.9264 6.57884 12 6.45634 12C6.23953 12 6.09255 11.7793 6.17613 11.5793L9.26419 4.18663Z"
      fill="white"
      stroke="white"
      strokeWidth="0.5"
    />
  </svg>
);

type BreadCrumbsProps = {
  items: BreadCrumb[] | null;
};

export const BreadCrumbs = ({ items }: BreadCrumbsProps) => {
  const dispatch = useAppDispatch();
  const {
    navigator: { setBackUrl },
  } = useContextData();

  if (!items || items.every((item) => item === null)) {
    return null;
  }

  return (
    <div className={styles.container}>
      {items.map((item, index) => {
        if (!item) {
          return null;
        }

        const isLast = index === items.length - 1;
        const { url, label } = item;

        return (
          <Fragment key={`bc-${index}-${label}`}>
            <Link
              src={url}
              className={cl(
                isLast ? styles.normal : styles.bold,
                !isLast && url && styles.url,
              )}
              disabled={!url}
              onClick={() => {
                if (!url) {
                  return;
                }

                dispatch(clearReportsHeadsetsState());
                setBackUrl(null);
              }}
            >
              {label}
            </Link>
            {!isLast && slashSVG}
          </Fragment>
        );
      })}
    </div>
  );
};

export default BreadCrumbs;
